import { ButtonT1, IconWithNameForButton } from "../../atoms/Button/Button";
import { Info } from "../../../assets/icons";
import {
  InstructionCardBody,
  InstructionCardFieldDesc,
  InstructionCardFieldInfo,
  InstructionCardFieldLabel,
  InstructionCardTitle,
} from "./topBar.styles";
import { Popover } from "../../molecules/Popover/Popover";
import { useManageMasterContext } from "../Provider/Manage";
import { useManageIntegrationContext } from "../Provider/ManageIntegration";
import { useCallback, useMemo, useState } from "react";
import { GENERAL_INSTRUCTIONS } from "../../../constant/data";

const contextConfig = {
  master: useManageMasterContext,
  integration: useManageIntegrationContext,
};

export const Instruction = ({ context = "master" }) => {
  const {
    activeStep,
    viewInstruction: { open, anchorEl },
    toggleInsruction,
    steps,
  } = contextConfig[context]();

  const btnTitle = useMemo(() => (open ? "Hide Instructions" : "View Instructions"), [open]);

  const { title, fields } = useMemo(() => steps?.[activeStep], [activeStep, steps]);

  return (
    <>
      <ButtonT1
        title={<IconWithNameForButton icon={Info} title={btnTitle} />}
        $variant="primaryLight"
        onClickCallback={toggleInsruction}
      />
      {open && anchorEl && (
        <Popover anchorEl={anchorEl} className="instruction" offset={[0, 38]}>
          <InstructionCardTitle>
            <Info />
            {title}
          </InstructionCardTitle>
          <InstructionCardBody>
            {Object.entries(fields).map(([key, value]) => (
              <InstructionCardFieldInfo key={key}>
                <InstructionCardFieldLabel>{key}</InstructionCardFieldLabel>
                <InstructionCardFieldDesc>{value}</InstructionCardFieldDesc>
              </InstructionCardFieldInfo>
            ))}
          </InstructionCardBody>
        </Popover>
      )}
    </>
  );
};
export const InstructionGeneral = ({ context }) => {
  const [viewInstruction, setViewInstruction] = useState({ open: false, anchorEl: null });

  const { open, anchorEl } = viewInstruction;

  const toggleInstruction = useCallback(event => {
    const el = event.currentTarget;
    setViewInstruction(prev => ({
      ...prev,
      open: !prev.open,
      anchorEl: prev.anchorEl ? null : el,
    }));
  }, []);

  const btnTitle = useMemo(() => (open ? "Hide Instructions" : "View Instructions"), [open]);

  const { title, fields } = GENERAL_INSTRUCTIONS[context];

  return (
    <>
      <ButtonT1
        title={<IconWithNameForButton icon={Info} title={btnTitle} />}
        $variant="primaryLight"
        onClickCallback={toggleInstruction}
      />
      {open && anchorEl && (
        <Popover anchorEl={anchorEl} className="instruction" offset={[0, 38]}>
          <InstructionCardTitle>
            <Info />
            {title}
          </InstructionCardTitle>
          <InstructionCardBody>
            {fields.map(({ label, description }) => (
              <InstructionCardFieldInfo key={label}>
                <InstructionCardFieldLabel>{label}</InstructionCardFieldLabel>
                <InstructionCardFieldDesc>{description}</InstructionCardFieldDesc>
              </InstructionCardFieldInfo>
            ))}
          </InstructionCardBody>
        </Popover>
      )}
    </>
  );
};
